import InFilter from '../../../common/support/utils/druid/filters/InFilter';

export const SPLIT_SKAN_MESSAGE = 'Toggle to view the split de-duplicated event counts from both SKAN and Non-SKAN sources.';

export const SKAN_UNIFIED_ANALYTICS_REQUIRED_FILTER = new InFilter('last_attributed_touch_data_tilde_feature', [
  'paid advertising',
]);

export const SKAN_UNIFIED_ANALYTICS_DEFAULT_FILTER_DIMENSIONS: string[] = [
  'last_attributed_touch_data_tilde_advertising_partner_name',
  'last_attributed_touch_data_tilde_campaign',
  'user_data_platform',
];

export const SKAN_UNIFIED_ANALYTICS_FILTER_DIMENSIONS: string[] = [
  ...SKAN_UNIFIED_ANALYTICS_DEFAULT_FILTER_DIMENSIONS,
  'attributed',
  'last_attributed_touch_data_tilde_campaign_id',
  'last_attributed_touch_data_dollar_3p',
];

export const SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS = {
  INSTALLS: 'eo_install',
  REINSTALLS: 'eo_reinstall',
  OPENS: 'eo_open',

  REVENUE: 'revenue',

  COMMERCE_PURCHASES: 'PURCHASE',
  COMMERCE_ADDS_TO_CART: 'ADD_TO_CART',
  COMMERCE_ADDS_TO_WISHLIST: 'ADD_TO_WISHLIST',
  COMMERCE_CART_VIEWS: 'VIEW_CART',
  COMMERCE_PURCHASE_INITS: 'INITIATE_PURCHASE',
  COMMERCE_PAYMENT_INFO_ADDS: 'ADD_PAYMENT_INFO',
  COMMERCE_CREDITS_SPENT: 'SPEND_CREDITS',
  COMMERCE_RESERVES: 'RESERVE',
  COMMERCE_AD_CLICKS: 'CLICK_AD',
  COMMERCE_AD_VIEWS: 'VIEW_AD',

  CONTENT_SEARCH: 'SEARCH',
  CONTENT_ITEM_VIEWS: 'VIEW_ITEM',
  CONTENT_ITEMS_VIEWS: 'VIEW_ITEMS',
  CONTENT_RATES: 'RATE',
  CONTENT_SHARES: 'SHARE',
  CONTENT_STREAM_INITS: 'INITIATE_STREAM',
  CONTENT_STREAM_COMPLETIONS: 'COMPLETE_STREAM',

  USER_LIFECYCLE_REGISTER_COMPLETIONS: 'COMPLETE_REGISTRATION',
  USER_LIFECYCLE_TUTORIAL_COMPLETIONS: 'COMPLETE_TUTORIAL',
  USER_LIFECYCLE_LEVEL_ACHIEVES: 'ACHIEVE_LEVEL',
  USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS: 'UNLOCK_ACHIEVEMENT',
  USER_LIFECYCLE_INVITES: 'INVITE',
  USER_LIFECYCLE_LOGINS: 'LOGIN',
  USER_LIFECYCLE_SUBSCRIPTIONS: 'SUBSCRIBE',
  USER_LIFECYCLE_TRIAL_STARTS: 'START_TRIAL',
  USER_LIFECYCLE_OPT_INS: 'OPT_IN',
  USER_LIFECYCLE_OPT_OUTS: 'OPT_OUT',
  USER_LIFECYCLE_UNINSTALL: 'UNINSTALL',
};

export const SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS = {
  INSTALLS: 'skan__install',
  REINSTALLS: 'skan__reinstall',
  OPENS: 'skan__open',

  REVENUE: 'skan__revenue',

  COMMERCE_PURCHASES: 'skan__commerce_purchase',
  COMMERCE_ADDS_TO_CART: 'skan__commerce_add_to_cart',
  COMMERCE_ADDS_TO_WISHLIST: 'skan__commerce_add_to_wishlist',
  COMMERCE_CART_VIEWS: 'skan__commerce_view_cart',
  COMMERCE_PURCHASE_INITS: 'skan__commerce_initiate_purchase',
  COMMERCE_PAYMENT_INFO_ADDS: 'skan__commerce_add_payment_info',
  COMMERCE_CREDITS_SPENT: 'skan__commerce_spend_credits',
  COMMERCE_RESERVES: 'skan__commerce_reserve',
  COMMERCE_AD_CLICKS: 'skan__commerce_click_ad',
  COMMERCE_AD_VIEWS: 'skan__commerce_view_ad',

  CONTENT_SEARCH: 'skan__content_search',
  CONTENT_ITEM_VIEWS: 'skan__content_view_item',
  CONTENT_ITEMS_VIEWS: 'skan__content_view_items',
  CONTENT_RATES: 'skan__content_rate',
  CONTENT_SHARES: 'skan__content_share',
  CONTENT_STREAM_INITS: 'skan__content_initiate_stream',
  CONTENT_STREAM_COMPLETIONS: 'skan__content_complete_stream',

  USER_LIFECYCLE_REGISTER_COMPLETIONS: 'skan__user_life_cycle_complete_registration',
  USER_LIFECYCLE_TUTORIAL_COMPLETIONS: 'skan__user_life_cycle_complete_tutorial',
  USER_LIFECYCLE_LEVEL_ACHIEVES: 'skan__user_life_cycle_achieve_level',
  USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS: 'skan__user_life_cycle_unlock_achievement',
  USER_LIFECYCLE_INVITES: 'skan__user_life_cycle_invite',
  USER_LIFECYCLE_LOGINS: 'skan__user_life_cycle_login',
  USER_LIFECYCLE_SUBSCRIPTIONS: 'skan__user_life_cycle_subscribe',
  USER_LIFECYCLE_TRIAL_STARTS: 'skan__user_life_cycle_start_trial',
  USER_LIFECYCLE_OPT_INS: 'skan__user_life_cycle_opt_in',
  USER_LIFECYCLE_OPT_OUTS: 'skan__user_life_cycle_opt_out',
  USER_LIFECYCLE_UNINSTALL: 'skan__user_life_cycle_uninstall',
};

export const SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS = {
  INSTALLS: 'unified_total__install',
  REINSTALLS: 'unified_total__reinstall',
  OPENS: 'unified_total__open',

  REVENUE: 'unified_total__revenue',

  COMMERCE_PURCHASES: 'unified_total__purchase',
  COMMERCE_ADDS_TO_CART: 'unified_total__add_to_cart',
  COMMERCE_ADDS_TO_WISHLIST: 'unified_total__add_to_wishlist',
  COMMERCE_CART_VIEWS: 'unified_total__view_cart',
  COMMERCE_PURCHASE_INITS: 'unified_total__initiate_purchase',
  COMMERCE_PAYMENT_INFO_ADDS: 'unified_total__add_payment_info',
  COMMERCE_CREDITS_SPENT: 'unified_total__spend_credits',
  COMMERCE_RESERVES: 'unified_total__reserve',
  COMMERCE_AD_CLICKS: 'unified_total__click_ad',
  COMMERCE_AD_VIEWS: 'unified_total__view_ad',

  CONTENT_SEARCH: 'unified_total__search',
  CONTENT_ITEM_VIEWS: 'unified_total__view_item',
  CONTENT_ITEMS_VIEWS: 'unified_total__view_items',
  CONTENT_RATES: 'unified_total__rate',
  CONTENT_SHARES: 'unified_total__share',
  CONTENT_STREAM_INITS: 'unified_total__initiate_stream',
  CONTENT_STREAM_COMPLETIONS: 'unified_total__complete_stream',

  USER_LIFECYCLE_REGISTER_COMPLETIONS: 'unified_total__complete_registration',
  USER_LIFECYCLE_TUTORIAL_COMPLETIONS: 'unified_total__complete_tutorial',
  USER_LIFECYCLE_LEVEL_ACHIEVES: 'unified_total__achieve_level',
  USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS: 'unified_total__unlock_achievement',
  USER_LIFECYCLE_INVITES: 'unified_total__invite',
  USER_LIFECYCLE_LOGINS: 'unified_total__login',
  USER_LIFECYCLE_SUBSCRIPTIONS: 'unified_total__subscribe',
  USER_LIFECYCLE_TRIAL_STARTS: 'unified_total__start_trial',
  USER_LIFECYCLE_OPT_INS: 'unified_total__opt_in',
  USER_LIFECYCLE_OPT_OUTS: 'unified_total__opt_out',
  USER_LIFECYCLE_UNINSTALL: 'unified_total__uninstall',
};

export const SKAN_UNIFIED_ANALYTICS_CALCULATION_COLUMNS = {
  CLICK_TO_TOTAL_INSTALL: 'skan__click_to_total_install',
  CLICK_TO_TOTAL_PURCHASE: 'skan__click_to_total_purchase',
  TOTAL_INSTALL_TO_COST: 'skan__total_install_to_cost',
  TOTAL_PURCHASE_TO_COST: 'skan__total_purchase_to_cost',
};

export const SKAN_UNIFIED_ANALYTICS_COLUMN_NAMES = {
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.INSTALLS]: 'Non SKAN install',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.REINSTALLS]: 'Non SKAN reinstall',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.OPENS]: 'Non SKAN open',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.REVENUE]: 'Non SKAN revenue',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASES]: 'Non SKAN purchase',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_CART]: 'Non SKAN add_to_cart',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'Non SKAN add_to_wishlist',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CART_VIEWS]: 'Non SKAN view_cart',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASE_INITS]: 'Non SKAN initiate_purchase',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'Non SKAN add_payment_info',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CREDITS_SPENT]: 'Non SKAN spend_credits',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_RESERVES]: 'Non SKAN reserve',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_CLICKS]: 'Non SKAN click_ad',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_VIEWS]: 'Non SKAN view_ad',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SEARCH]: 'Non SKAN search',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEM_VIEWS]: 'Non SKAN view_item',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEMS_VIEWS]: 'Non SKAN view_items',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_RATES]: 'Non SKAN rate',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SHARES]: 'Non SKAN share',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_INITS]: 'Non SKAN initiate_stream',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'Non SKAN complete_stream',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'Non SKAN complete_registration',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'Non SKAN complete_tutorial',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'Non SKAN achieve_level',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'Non SKAN unlock_achievement',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_INVITES]: 'Non SKAN invite',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LOGINS]: 'Non SKAN login',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'Non SKAN subscribe',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'Non SKAN start_trial',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'Non SKAN opt_in',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'Non SKAN opt_out',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_UNINSTALL]: 'Non SKAN uninstall',

  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.INSTALLS]: 'SKAN install',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.REINSTALLS]: 'SKAN reinstall',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.OPENS]: 'SKAN open',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.REVENUE]: 'SKAN revenue',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASES]: 'SKAN purchase',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_CART]: 'SKAN add_to_cart',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'SKAN add_to_wishlist',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_CART_VIEWS]: 'SKAN view_cart',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASE_INITS]: 'SKAN initiate_purchase',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'SKAN add_payment_info',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_CREDITS_SPENT]: 'SKAN spend_credits',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_RESERVES]: 'SKAN reserve',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_CLICKS]: 'SKAN click_ad',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_VIEWS]: 'SKAN view_ad',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_SEARCH]: 'SKAN search',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEM_VIEWS]: 'SKAN view_item',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEMS_VIEWS]: 'SKAN view_items',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_RATES]: 'SKAN rate',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_SHARES]: 'SKAN share',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_INITS]: 'SKAN initiate_stream',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'SKAN complete_stream',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'SKAN complete_registration',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'SKAN complete_tutorial',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'SKAN achieve_level',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'SKAN unlock_achievement',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_INVITES]: 'SKAN invite',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LOGINS]: 'SKAN login',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'SKAN subscribe',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'SKAN start_trial',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'SKAN opt_in',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'SKAN opt_out',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_UNINSTALL]: 'SKAN uninstall',

  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.INSTALLS]: 'Unified installs',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.REINSTALLS]: 'Unified reinstalls',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.OPENS]: 'Unified opens',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.REVENUE]: 'Unified revenue',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASES]: 'Unified purchases',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_CART]: 'Unified add_to_cart',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'Unified add_to_wishlist',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CART_VIEWS]: 'Unified view_cart',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASE_INITS]: 'Unified initiate_purchase',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'Unified add_payment_info',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CREDITS_SPENT]: 'Unified spend_credits',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_RESERVES]: 'Unified reserve',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_CLICKS]: 'Unified click_ad',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_VIEWS]: 'Unified view_ad',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_SEARCH]: 'Unified search',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEM_VIEWS]: 'Unified view_item',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEMS_VIEWS]: 'Unified view_items',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_RATES]: 'Unified rate',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_SHARES]: 'Unified share',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_INITS]: 'Unified initiate_stream',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'Unified complete_stream',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'Unified complete_registration',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'Unified complete_tutorial',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'Unified achieve_level',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'Unified unlock_achievement',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_INVITES]: 'Unified invite',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LOGINS]: 'Unified login',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'Unified subscribe',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'Unified start_trial',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'Unified opt_in',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'Unified opt_out',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_UNINSTALL]: 'Unified uninstall',

  [SKAN_UNIFIED_ANALYTICS_CALCULATION_COLUMNS.CLICK_TO_TOTAL_INSTALL]: 'Click to install rate',
  [SKAN_UNIFIED_ANALYTICS_CALCULATION_COLUMNS.CLICK_TO_TOTAL_PURCHASE]: 'Click to purchase rate',
  [SKAN_UNIFIED_ANALYTICS_CALCULATION_COLUMNS.TOTAL_INSTALL_TO_COST]: 'eCPI',
  [SKAN_UNIFIED_ANALYTICS_CALCULATION_COLUMNS.TOTAL_PURCHASE_TO_COST]: 'eCPP',
};

export const SKAN_UNIFIED_ANALYTICS_COLUMN_TOOLTIPS = {
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.INSTALLS]: 'De-duplicated installs from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.REINSTALLS]: 'De-duplicated reinstalls from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.OPENS]: 'De-duplicated opens from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.REVENUE]: 'De-duplicated revenue from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASES]: 'De-duplicated purchases from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_CART]:
    'De-duplicated adds to cart from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]:
    'De-duplicated adds to wishlist from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CART_VIEWS]: 'De-duplicated cart views from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASE_INITS]:
    'De-duplicated purchase initiations from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]:
    'De-duplicated payment info adds from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CREDITS_SPENT]:
    'De-duplicated credit spends from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_RESERVES]: 'De-duplicated reserves from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_CLICKS]: 'De-duplicated ad clicks from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_VIEWS]: 'De-duplicated ad views from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SEARCH]: 'De-duplicated searches from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEM_VIEWS]: 'De-duplicated item views from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEMS_VIEWS]: 'De-duplicated items views from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_RATES]: 'De-duplicated rates from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SHARES]: 'De-duplicated shares from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_INITS]:
    'De-duplicated stream initiations from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS]:
    'De-duplicated stream completions from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]:
    'De-duplicated registration completions from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]:
    'De-duplicated tutorial completions from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]:
    'De-duplicated level achieves from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]:
    'De-duplicated achievement unlocks from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_INVITES]: 'De-duplicated invites from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LOGINS]: 'De-duplicated logins from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]:
    'De-duplicated subscriptions from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]:
    'De-duplicated trial starts from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'De-duplicated opt ins from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS]:
    'De-duplicated opt outs from Device ID based Attribution',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_UNINSTALL]:
    'De-duplicated uninstall from Device ID based Attribution',

  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.INSTALLS]: 'De-duplicated SKAN Attributed installs',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.REINSTALLS]: 'De-duplicated SKAN Attributed reinstalls',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.OPENS]: 'De-duplicated SKAN Attributed opens',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.REVENUE]: 'De-duplicated SKAN Attributed revenue',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASES]: 'De-duplicated SKAN Attributed purchases',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_CART]: 'De-duplicated SKAN Attributed adds to cart',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'De-duplicated SKAN Attributed adds to wishlist',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_CART_VIEWS]: 'De-duplicated SKAN Attributed cart views',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASE_INITS]: 'De-duplicated SKAN Attributed purchase initiations',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'De-duplicated SKAN Attributed payment info adds',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_CREDITS_SPENT]: 'De-duplicated SKAN Attributed credit spends',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_RESERVES]: 'De-duplicated SKAN Attributed reserves',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_CLICKS]: 'De-duplicated SKAN Attributed ad clicks',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_VIEWS]: 'De-duplicated SKAN Attributed ad views',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_SEARCH]: 'De-duplicated SKAN Attributed searches',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEM_VIEWS]: 'De-duplicated SKAN Attributed item views',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEMS_VIEWS]: 'De-duplicated SKAN Attributed items views',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_RATES]: 'De-duplicated SKAN Attributed rates',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_SHARES]: 'De-duplicated SKAN Attributed shares',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_INITS]: 'De-duplicated SKAN Attributed stream initiations',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'De-duplicated SKAN Attributed stream completions',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]:
    'De-duplicated SKAN Attributed register completions',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]:
    'De-duplicated SKAN Attributed tutorial completions',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'De-duplicated SKAN Attributed level achieves',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]:
    'De-duplicated SKAN Attributed achievement unlocks',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_INVITES]: 'De-duplicated SKAN Attributed invites',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LOGINS]: 'De-duplicated SKAN Attributed logins',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'De-duplicated SKAN Attributed subscriptions',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'De-duplicated SKAN Attributed trial starts',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'De-duplicated SKAN Attributed opt ins',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'De-duplicated SKAN Attributed opt outs',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_UNINSTALL]: 'De-duplicated SKAN Attributed uninstalls',

  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.INSTALLS]: 'Unified Total installs from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.REINSTALLS]: 'Unified Total reinstalls from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.OPENS]: 'Unified Total opens from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.REVENUE]: 'Unified Total revenue from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASES]: 'Unified Total purchases from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_CART]:
    'Unified Total adds to cart from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]:
    'Unified Total adds to wishlist from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CART_VIEWS]:
    'Unified Total cart views from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASE_INITS]:
    'Unified Total purchase initations from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]:
    'Unified Total payment info adds from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CREDITS_SPENT]:
    'Unified Total credit spends from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_RESERVES]: 'Unified Total reserves from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_CLICKS]: 'Unified Total ad clicks from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_VIEWS]: 'Unified Total ad views from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_SEARCH]: 'Unified Total searches from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEM_VIEWS]: 'Unified Total item views from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEMS_VIEWS]:
    'Unified Total items views from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_RATES]: 'Unified Total rates from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_SHARES]: 'Unified Total shares from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_INITS]:
    'Unified Total stream initations from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_COMPLETIONS]:
    'Unified Total stream completions from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]:
    'Unified Total register completions from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]:
    'Unified Total tutorial completions from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]:
    'Unified Total level achieves from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]:
    'Unified Total achievement unlocks from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_INVITES]:
    'Unified Total invites from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LOGINS]: 'Unified Total logins from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]:
    'Unified Total subscriptions from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]:
    'Unified Total trial starts from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_INS]:
    'Unified Total opt ins from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_OUTS]:
    'Unified Total opt outs from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_UNINSTALL]:
    'Unified Total uninstalls from both SKAN and Non-SKAN sources',

  [SKAN_UNIFIED_ANALYTICS_CALCULATION_COLUMNS.TOTAL_INSTALL_TO_COST]:
    'Effective Cost Per Install: cost divided by number of installs',
  [SKAN_UNIFIED_ANALYTICS_CALCULATION_COLUMNS.TOTAL_PURCHASE_TO_COST]:
    'Effective Cost Per Purchase: cost divided by number of purchases',
};

export const SKAN_UNIFIED_ANALYTICS_GROUPS = {
  SKAN_UNIFIED_GROUP_INSTALLS: 'skan_unified_install_group',
  SKAN_UNIFIED_GROUP_REINSTALLS: 'skan_unified_reinstall_group',
  SKAN_UNIFIED_GROUP_OPENS: 'skan_unified_open_group',
  SKAN_UNIFIED_GROUP_REVENUE: 'skan_unified_revenue_group',
  SKAN_UNIFIED_GROUP_COMMERCE_PURCHASES: 'skan_unified_commerce_purchases_group',
  SKAN_UNIFIED_GROUP_COMMERCE_ADDS_TO_CART: 'skan_unified_commerce_add_to_cart_group',
  SKAN_UNIFIED_GROUP_COMMERCE_ADDS_TO_WISHLIST: 'skan_unified_commerce_add_to_wishlist_group',
  SKAN_UNIFIED_GROUP_COMMERCE_CART_VIEWS: 'skan_unified_commerce_view_cart_group',
  SKAN_UNIFIED_GROUP_COMMERCE_PURCHASE_INITS: 'skan_unified_commerce_initiate_purchase_group',
  SKAN_UNIFIED_GROUP_COMMERCE_PAYMENT_INFO_ADDS: 'skan_unified_commerce_add_payment_info_group',
  SKAN_UNIFIED_GROUP_COMMERCE_CREDITS_SPENT: 'skan_unified_commerce_spend_credits_group',
  SKAN_UNIFIED_GROUP_COMMERCE_RESERVES: 'skan_unified_commerce_reserve_group',
  SKAN_UNIFIED_GROUP_COMMERCE_AD_CLICKS: 'skan_unified_commerce_click_ad_group',
  SKAN_UNIFIED_GROUP_COMMERCE_AD_VIEWS: 'skan_unified_commerce_view_ad_group',
  SKAN_UNIFIED_GROUP_CONTENT_SEARCH: 'skan_unified_content_search_group',
  SKAN_UNIFIED_GROUP_CONTENT_ITEM_VIEWS: 'skan_unified_content_view_item_group',
  SKAN_UNIFIED_GROUP_CONTENT_ITEMS_VIEWS: 'skan_unified_content_view_items_group',
  SKAN_UNIFIED_GROUP_CONTENT_RATES: 'skan_unified_content_rate_group',
  SKAN_UNIFIED_GROUP_CONTENT_SHARES: 'skan_unified_content_share_group',
  SKAN_UNIFIED_GROUP_CONTENT_STREAM_INITS: 'skan_unified_content_initiate_stream_group',
  SKAN_UNIFIED_GROUP_CONTENT_STREAM_COMPLETIONS: 'skan_unified_content_complete_stream_group',
  SKAN_UNIFIED_GROUP_USER_LIFECYCLE_REGISTER_COMPLETIONS: 'skan_unified_lifecycle_complete_registration_group',
  SKAN_UNIFIED_GROUP_USER_LIFECYCLE_TUTORIAL_COMPLETIONS: 'skan_unified_lifecycle_complete_tutorial_group',
  SKAN_UNIFIED_GROUP_USER_LIFECYCLE_LEVEL_ACHIEVES: 'skan_unified_lifecycle_achieve_level_group',
  SKAN_UNIFIED_GROUP_USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS: 'skan_unified_lifecycle_unlock_achievement_group',
  SKAN_UNIFIED_GROUP_USER_LIFECYCLE_INVITES: 'skan_unified_lifecycle_invite_group',
  SKAN_UNIFIED_GROUP_USER_LIFECYCLE_LOGINS: 'skan_unified_lifecycle_login_group',
  SKAN_UNIFIED_GROUP_USER_LIFECYCLE_SUBSCRIPTIONS: 'skan_unified_lifecycle_subscribe_group',
  SKAN_UNIFIED_GROUP_USER_LIFECYCLE_TRIAL_STARTS: 'skan_unified_lifecycle_start_trial_group',
  SKAN_UNIFIED_GROUP_USER_LIFECYCLE_OPT_INS: 'skan_unified_lifecycle_opt_in_group',
  SKAN_UNIFIED_GROUP_USER_LIFECYCLE_OPT_OUTS: 'skan_unified_lifecycle_opt_out_group',
  SKAN_UNIFIED_GROUP_USER_LIFECYCLE_UNINSTALLS: 'skan_unified_lifecycle_uninstall_group',
};

export const SKAN_UNIFIED_ANALYTICS_GROUP_NAMES = {
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_INSTALLS]: 'install',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_REINSTALLS]: 'reinstall',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_OPENS]: 'open',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_REVENUE]: 'revenue',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_PURCHASES]: 'PURCHASE',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_ADDS_TO_CART]: 'ADD_TO_CART',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_ADDS_TO_WISHLIST]: 'ADD_TO_WISHLIST',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_CART_VIEWS]: 'VIEW_CART',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_PURCHASE_INITS]: 'INITIATE_PURCHASE',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_PAYMENT_INFO_ADDS]: 'ADD_PAYMENT_INFO',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_CREDITS_SPENT]: 'SPEND_CREDITS',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_RESERVES]: 'RESERVE',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_AD_CLICKS]: 'CLICK_AD',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_AD_VIEWS]: 'VIEW_AD',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_CONTENT_SEARCH]: 'SEARCH',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_CONTENT_ITEM_VIEWS]: 'VIEW_ITEM',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_CONTENT_ITEMS_VIEWS]: 'VIEW_ITEMS',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_CONTENT_RATES]: 'RATE',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_CONTENT_SHARES]: 'SHARE',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_CONTENT_STREAM_INITS]: 'INITIATE_STREAM',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_CONTENT_STREAM_COMPLETIONS]: 'COMPLETE_STREAM',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'COMPLETE_REGISTRATION',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'COMPLETE_TUTORIAL',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_LEVEL_ACHIEVES]: 'ACHIEVE_LEVEL',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'UNLOCK_ACHIEVEMENT',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_INVITES]: 'INVITE',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_LOGINS]: 'LOGIN',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_SUBSCRIPTIONS]: 'SUBSCRIBE',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_TRIAL_STARTS]: 'START_TRIAL',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_OPT_INS]: 'OPT_IN',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_OPT_OUTS]: 'OPT_OUT',
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_UNINSTALLS]: 'UNINSTALL',
};

export const SKAN_UNIFIED_ANALYTICS_GROUP_COLUMN_NAMES = {
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.INSTALLS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.REINSTALLS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.OPENS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.REVENUE]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASES]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_CART]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CART_VIEWS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASE_INITS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CREDITS_SPENT]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_RESERVES]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_CLICKS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_VIEWS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SEARCH]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEM_VIEWS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEMS_VIEWS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_RATES]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SHARES]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_INITS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_INVITES]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LOGINS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'Non SKAN',
  [SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_UNINSTALL]: 'Non SKAN',

  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.INSTALLS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.REINSTALLS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.OPENS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.REVENUE]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASES]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_CART]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_CART_VIEWS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASE_INITS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_CREDITS_SPENT]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_RESERVES]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_CLICKS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_VIEWS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_SEARCH]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEM_VIEWS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEMS_VIEWS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_RATES]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_SHARES]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_INITS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_INVITES]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LOGINS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'SKAN',
  [SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_UNINSTALL]: 'SKAN',

  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.INSTALLS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.REINSTALLS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.OPENS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.REVENUE]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASES]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_CART]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CART_VIEWS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASE_INITS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CREDITS_SPENT]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_RESERVES]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_CLICKS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_VIEWS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_SEARCH]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEM_VIEWS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEMS_VIEWS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_RATES]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_SHARES]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_INITS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_INVITES]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LOGINS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'Total',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_UNINSTALL]: 'Total',
};

export const SKAN_UNIFIED_ANALYTICS_GROUP_COLUMN_TOOLTIPS = {
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.INSTALLS]: 'Sum of Deduplicated installs from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.REINSTALLS]: 'Sum of Deduplicated reinstalls from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.OPENS]: 'Sum of Deduplicated opens from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.REVENUE]: 'Sum of Deduplicated revenue from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASES]:
    'Sum of Deduplicated purchases from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_CART]:
    'Sum of Deduplicated adds to cart from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]:
    'Sum of Deduplicated adds to wishlist from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CART_VIEWS]:
    'Sum of Deduplicated cart views from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASE_INITS]:
    'Sum of Deduplicated purchase initiations from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]:
    'Sum of Deduplicated payment info adds from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CREDITS_SPENT]:
    'Sum of Deduplicated credit spends from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_RESERVES]:
    'Sum of Deduplicated reserves from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_CLICKS]:
    'Sum of Deduplicated ad clicks from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_VIEWS]:
    'Sum of Deduplicated ad views from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_SEARCH]: 'Sum of Deduplicated searches from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEM_VIEWS]:
    'Sum of Deduplicated item views from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEMS_VIEWS]:
    'Sum of Deduplicated items views from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_RATES]: 'Sum of Deduplicated rates from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_SHARES]: 'Sum of Deduplicated shares from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_INITS]:
    'Sum of Deduplicated stream initiations from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_COMPLETIONS]:
    'Sum of Deduplicated stream completions from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]:
    'Sum of Deduplicated register completions from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]:
    'Sum of Deduplicated tutorial completions from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]:
    'Sum of Deduplicated level achieves from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]:
    'Sum of Deduplicated achievement unlocks from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_INVITES]:
    'Sum of Deduplicated invites from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LOGINS]:
    'Sum of Deduplicated logins from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]:
    'Sum of Deduplicated subscriptions from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]:
    'Sum of Deduplicated trial starts from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_INS]:
    'Sum of Deduplicated opt ins from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_OUTS]:
    'Sum of Deduplicated opt outs from both SKAN and Non-SKAN sources',
  [SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_UNINSTALL]:
    'Sum of Deduplicated uninstalls from both SKAN and Non-SKAN sources',
};

export const SKAN_UNIFIED_ANALYTICS_GROUP_COLUMNS = {
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_INSTALLS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.INSTALLS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.INSTALLS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.INSTALLS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_REINSTALLS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.REINSTALLS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.REINSTALLS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.REINSTALLS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_OPENS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.OPENS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.OPENS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.OPENS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_REVENUE]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.REVENUE,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.REVENUE,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.REVENUE,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_PURCHASES]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASES,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASES,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASES,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_ADDS_TO_CART]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_CART,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_CART,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_CART,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_ADDS_TO_WISHLIST]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_WISHLIST,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_CART_VIEWS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CART_VIEWS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_CART_VIEWS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CART_VIEWS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_PURCHASE_INITS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASE_INITS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASE_INITS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASE_INITS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_PAYMENT_INFO_ADDS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_CREDITS_SPENT]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CREDITS_SPENT,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_CREDITS_SPENT,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CREDITS_SPENT,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_RESERVES]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_RESERVES,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_RESERVES,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_RESERVES,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_AD_CLICKS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_CLICKS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_CLICKS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_CLICKS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_COMMERCE_AD_VIEWS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_VIEWS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_VIEWS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_VIEWS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_CONTENT_SEARCH]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SEARCH,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_SEARCH,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_SEARCH,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_CONTENT_ITEM_VIEWS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEM_VIEWS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEM_VIEWS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEM_VIEWS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_CONTENT_ITEMS_VIEWS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEMS_VIEWS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEMS_VIEWS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEMS_VIEWS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_CONTENT_RATES]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_RATES,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_RATES,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_RATES,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_CONTENT_SHARES]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SHARES,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_SHARES,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_SHARES,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_CONTENT_STREAM_INITS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_INITS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_INITS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_INITS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_CONTENT_STREAM_COMPLETIONS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_COMPLETIONS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_REGISTER_COMPLETIONS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_LEVEL_ACHIEVES]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_INVITES]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_INVITES,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_INVITES,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_INVITES,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_LOGINS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LOGINS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LOGINS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LOGINS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_SUBSCRIPTIONS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_TRIAL_STARTS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_OPT_INS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_INS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_INS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_INS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_OPT_OUTS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_OUTS,
  ],
  [SKAN_UNIFIED_ANALYTICS_GROUPS.SKAN_UNIFIED_GROUP_USER_LIFECYCLE_UNINSTALLS]: [
    SKAN_UNIFIED_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_UNINSTALL,
    SKAN_UNIFIED_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_UNINSTALL,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_UNINSTALL,
  ],
};

export const SKAN_UNIFIED_ANALYTICS_DEFAULT_SPLIT_SKAN_DATA_CHECKED = false;

export const SKAN_UNIFIED_ANALYTICS_DEFAULT_ACTIVE_COLUMN = 'eo_click';

export const SKAN_UNIFIED_ANALYTICS_DEFAULT_SELECTED_COLUMNS = [
  ...new Set([
    'cost',
    SKAN_UNIFIED_ANALYTICS_DEFAULT_ACTIVE_COLUMN,
    SKAN_UNIFIED_ANALYTICS_TOTALS_COLUMNS.INSTALLS,
    SKAN_UNIFIED_ANALYTICS_CALCULATION_COLUMNS.CLICK_TO_TOTAL_INSTALL,
    SKAN_UNIFIED_ANALYTICS_CALCULATION_COLUMNS.TOTAL_INSTALL_TO_COST,
  ]),
];
